import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {LOCATION__16} from '@homeaway/svg-defs';

function DistanceFrom({text}) {
    return (
        <div className="CommonRatioCard__distance-from">
            <span className="location-svg-icon">
                <SVGIcon markup={LOCATION__16} />
            </span>
            {text}
        </div>
    );
}

export default React.memo(DistanceFrom);
